var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center flex-column mt-5 mb-5"},[_c('a',{staticClass:"btn",attrs:{"href":"#"}},[_vm._v("PLAY NOW")])])}]

export { render, staticRenderFns }